import { Box, LinearProgress, Typography } from "@mui/material";
import { useEffect, useRef } from "react";
import { useRefreshToken } from "./api";

export const RefreshingTokenPage: React.FC = () => {
  const refreshTokenMutation = useRefreshToken();
  const isRefreshing = useRef(false);
  useEffect(() => {
    if (!refreshTokenMutation.isPending && !isRefreshing.current) {
      // Set the ref to true BEFORE calling mutate
      isRefreshing.current = true;

      refreshTokenMutation.mutate("", {
        onSuccess: (data) => {
          // if (authStore.lastFailedRoute) {
          //     navigate(authStore.lastFailedRoute, { replace: true });
          //     console.log('Navigated to last failed route!');
          // }
          // else if (window.history.length > 1) {
          //     window.history.back();
          //     window.history.back();
          //     console.log('Navigated Back!');
          // } else {
          //     window.location.reload();
          //     console.log('Relaoded!');
          // }
        },
        onError: (error) => {
          console.error("Token refresh failed:", error);
          // If refresh fails, you might want to reset the ref to allow a retry on next render,
          // or navigate to login. For now, navigate to login after failure.
          // Also consider resetting here if you want to allow retries.
          isRefreshing.current = false; // Allow retry on next render
          // Immediately navigate to login on error
          // You might want to use a toast/notification here too
          // Example:
          // resetStorage(); // Clear local/session storage
          // navigate('/login', { state: { error: 'Session expired' } }); // Use useNavigate hook
        },
      });
    }
  });

  return (
    <Box
      sx={{
        width: "100vw",
        height: "100vh",
        border: "1px solid red",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
      }}
    >
      <img src="/data-security.svg" alt="No Data" style={{ maxHeight: 300 }} />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          pb: "100px",
        }}
      >
        <Box sx={{ width: "100%", mb: "20px" }}>
          <LinearProgress />
        </Box>
        <Typography variant="body2" fontStyle="italic" color="text.secondary">
          Keeping things secure. One sec!
        </Typography>
      </Box>
    </Box>
  );
};
